




















































































import CAvatar from '~/components/shared/configurable/image/avatar/CAvatar.vue'
import {
  NotificationEvent,
  NotificationTypeEnum
} from '~/models/notification-center/types'
import { formatNumber, formatPercentage } from '~/utils/number'
import { defineComponent, PropType } from '@nuxtjs/composition-api'

export default defineComponent({
  components: {
    CAvatar
  },
  props: {
    notifications: {
      type: Array as PropType<NotificationEvent[]>,
      required: true
    },
    displayInPage: { type: Boolean, default: false }
  },
  computed: {
    notificationTypeEnum() {
      return NotificationTypeEnum
    }
  },
  methods: {
    newPrice(notification: NotificationEvent) {
      return `${formatNumber(notification.data.newPrice)}€`
    },
    oldPrice(notification: NotificationEvent) {
      return `${formatNumber(notification.data.oldPrice)}€`
    },
    priceReduction(notification: NotificationEvent) {
      return `${((notification.data.oldPrice - notification.data.newPrice) /
        notification.data.oldPrice) |
        formatPercentage(0)}%`
    }
  }
})
